import { render, staticRenderFns } from "./record-alarm.vue?vue&type=template&id=7993da08"
import script from "./record-alarm.vue?vue&type=script&lang=js"
export * from "./record-alarm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports